export default function NonTradableAssetBannerIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="19.9996" cy="19.9999" r="18" stroke="#B5B5B5" strokeWidth="0.8" />
      <circle
        cx="19.9999"
        cy="19.9999"
        r="15.4714"
        stroke="#B5B5B5"
        strokeWidth="0.6"
        strokeLinejoin="bevel"
        strokeDasharray="0.4 0.4"
      />
      <path
        d="M23.1288 23.5916C21.7797 25.3257 20.7045 27.412 20.0008 29.554C19.297 27.412 18.2219 25.3257 16.8727 23.5916C15.5383 21.8764 13.9185 20.4847 12.1044 19.7422C13.9185 18.9997 15.5383 17.6079 16.8727 15.8928C18.2219 14.1587 19.297 12.0723 20.0008 9.93028C20.7045 12.0723 21.7797 14.1587 23.1288 15.8928C24.4632 17.6079 26.083 18.9997 27.8972 19.7422C26.083 20.4847 24.4632 21.8764 23.1288 23.5916Z"
        fill="url(#paint0_linear_1174_15479)"
        fillOpacity="0.8"
        stroke="#B5B5B5"
        strokeWidth="0.8"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1174_15479"
          x1="29.2961"
          y1="30.8678"
          x2="12.713"
          y2="30.3195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7A95FF" stopOpacity="0.29" />
          <stop offset="1" stopColor="#3760FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
